import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

import { MyCustomModalService } from '@hosty-web/services';

import { AccountBlockedComponent } from '../../modules/accounts/components/account-blocked/account-blocked.component';

@Injectable({
  providedIn: 'root',
})
export class BlockUserInterceptor implements HttpInterceptor {
  constructor(
    private readonly modalService: MyCustomModalService,
    private readonly route: Router,
  ) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // This interceptor is registered last, so it is the *first* to see every
        // error. `error.error` is null for empty bodies and a ProgressEvent for
        // network failures, so reading `.error` off it unguarded threw a
        // TypeError that replaced the HttpErrorResponse — which meant the
        // refresh interceptor upstream never saw `status === 401` and the
        // session was dropped instead of refreshed.
        const code = typeof error?.error?.error === 'string' ? error.error.error : null;

        if (
          (code === 'access_denied_user_without_subscription_active' ||
            code === 'access_denied_user_without_active_card') &&
          this.route.url !== '/profile/subscriptions'
        ) {
          if (!this.modalService.currentModal) {
            this.modalService.open(AccountBlockedComponent, {
              disableClose: true,
              hasBackdrop: true,
              data: {
                cardIssue: code.includes('card'),
                subscriptionIssue: code.includes('subscription'),
              },
            });
          }
        }
        return throwError(error);
      }),
    );
  }
}
